<template>
  <v-card class="mb-2 card-mensagem" :class="selecionada ? 'card-selecionado' : 'card-normal'">
    <v-card-text class="pb-0">
      <v-form ref="formMensagem">
        <v-textarea v-if="editando" dense outlined flat solo clearable auto-grow no-resize
                    color="#0090E9" v-model="novaMensagem" ref="campoMensagem" @keyup.esc="cancelarEdicao"
                    placeholder="Adicione a mensagem do mercado destino" :rules="[OBRIGATORIO]" />
        <div v-else>
          <pre class="mensagem-text">{{ novaMensagem }}</pre>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions class="pt-0">
      <confirmation-dialog :item="mensagem" deletar @confirmed="deletarMensagem"
                       titulo="Deletar mensagem mercado destino"
                       ds-acao="Deseja mesmo deletar a mensagem do mercado destino?"
                       mensagem="Ao deletar essa mensagem do mercado destino todos os boletins sanitários que a utilizam serão alterados."
                       v-if="!adicionando">
        <template v-slot:activator="{ on }">
          <v-btn icon :loading="deleting" v-on="on">
            <v-icon size="16" color="#799596">fas fa-trash</v-icon>
          </v-btn>
        </template>
      </confirmation-dialog>
      <v-spacer />
      <v-btn color="#799596" text v-if="!editando" @click="editar" :retain-focus-on-click="false">EDITAR</v-btn>
      <v-btn color="#799596" text v-else @click="cancelarEdicao" :retain-focus-on-click="false">CANCELAR</v-btn>

      <v-btn color="#00A5A2" text v-if="!editando" :loading="loading" @click="selecionar"
             :retain-focus-on-click="false">
        {{ !selecionada ? 'SELECIONAR' : 'DESSELECIONAR' }}
      </v-btn>
      <v-btn color="#00A5A2" text v-else :loading="loading" @click="salvarEdicao"
             :retain-focus-on-click="false">SALVAR
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {MODELS, RULES} from "../../resources";
import ConfirmationDialog from "../ConfirmationDialog";

export default {
  name: "MensagemMercadoDestinoCard",
  components: {ConfirmationDialog},
  props: {
    value: Array,
    mensagem: {
      type: Object,
      required: true,
    },
    adicionando: Boolean,

  },
  data: () => ({
    editando: false,
    loading: false,
    deleting: false,
    novaMensagem: '',
  }),
  computed: {
    selecionada() {
      if (!this.value) return false
      return _.includes(this.value, this.mensagem.idMensagemBoletimSanitario)
    }
  },
  methods: {
    ...RULES,
    editar() {
      this.novaMensagem = this.mensagem.dsMensagemBoletimSanitario
      this.editando = true
      this.$refs.campoMensagem.focus()
    },
    cancelarEdicao() {
      if (!this.editando) return
      if (this.mensagem.idMensagemBoletimSanitario === 0) this.$emit('deletarMensagem')
      this.novaMensagem = this.mensagem.dsMensagemBoletimSanitario
      this.editando = false
    },
    selecionar() {
      this.$emit('input', _.xor(this.value, [this.mensagem.idMensagemBoletimSanitario]))
    },
    deletarMensagem() {
      if (this.mensagem.idMensagemBoletimSanitario > 0) {
        this.$axios.delete(`mensagem-boletim-sanitario/${this.mensagem.idMensagemBoletimSanitario}`)
            .catch(error => {
              this.$store.commit("setSnack", {type: "error", msg: error});
            })
      }
      this.$emit('deletarMensagem')
    },
    salvarEdicao() {
      if (!this.$refs.formMensagem.validate()) return
      this.loading = true

      const configReq = this.mensagem.idMensagemBoletimSanitario > 0 ?
          {
            url: `mensagem-boletim-sanitario/${this.mensagem.idMensagemBoletimSanitario}`,
            method: 'put',
            data: new MODELS.MENSAGEM_MERCADO_DESTINO(this.novaMensagem, this.mensagem.idMensagemBoletimSanitario),
          } :
          {
            url: 'mensagem-boletim-sanitario/',
            method: 'post',
            data: new MODELS.MENSAGEM_MERCADO_DESTINO(this.novaMensagem, this.mensagem.idMensagemBoletimSanitario),
          }

      this.$axios.request(configReq)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            if (configReq.method === 'post')
              this.$emit('novaMensagem', res.data[0].data)
            else
              this.$emit('update:mensagem', {...res.data[0].data, id: this.mensagem.id})
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => {
            this.loading = false
            this.editando = false
          })
    },
  },
  mounted() {
    this.novaMensagem = this.mensagem.dsMensagemBoletimSanitario
    if (this.mensagem.idMensagemBoletimSanitario === 0) this.editando = true
  }
}
</script>

<style scoped>
.mensagem-text {
  font: 400 normal normal 16px/28px Roboto, sans-serif;
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-wrap;
}

.card-selecionado {
  border: 1px solid #00C1B6;
  background-color: #FAFAFA;
}

.card-normal {
  border: 1px solid transparent;
}

</style>